export default "__VITE_ASSET__Clo9mJ_E__"